(function () {
	'use strict';

	angular
		.module('app.myWork')
		.controller('myProjectTasks', myProjectTasks);

	myProjectTasks.$inject = ['$rootScope', '$scope', '$timeout', '$location', 'slideInModalService', 'myWorkService', 'a3ModalService', 'notificationService'];

	function myProjectTasks($rootScope, $scope, $timeout, $location, slideInModalService, myWorkService, a3ModalService, notificationService) {
		var vm = this;
		var reportSettingsName = 'myProjectTasks';
		var instance, opened;
		globalReportName = reportSettingsName;
		$scope.openSlideIn = openSlideIn;
		$scope.viewA3Report = viewA3Report;
		$timeout(function () {
			jQuery('li.list-group-item.selected').removeClass('selected');
			jQuery('#viewMyProjectTasks').addClass('selected');
		}, 0);
		
		notificationService.getUnreadInventoryActions(true);
		
		function openSlideIn(args) {
			var template = '';
			var projectObj = {
				projectName: args.projectName,
				projectId: args.projectId,
				parentNdx: args.projectNdx,
				projectEndDate: args.projectEndDate,
				tableName: args.tableName,
				fromMyWorkTab: true
			};
			var myWorkLeanProjectSlide = false;
			switch (args.type) {
			case 'Task':
				myWorkService.setTask(projectObj);
				template = '/application/f/my-work/project-task-panel.html';
				break;
			case 'Issue':
				myWorkService.setTask(projectObj);
				template = '/application/f/my-work/project-issue-panel.html';
				break;
			case 'Project':
				myWorkLeanProjectSlide = true;
				template = '/application/f/lean-projects/projects/edit-project.html';
				var search = $location.search();
				search.projectNdx = args.projectNdx;
				search.factoryNdx = args.factoryNdx;
				search.insidePanel = true;
				search.tableName = args.tableName;
				break;
			}
			var slideInScope = $scope.$new();
			slideInScope.fromMyWorkTab = true;
			slideInScope.myWorkLeanProjectSlide = myWorkLeanProjectSlide;
			slideInScope.closeDialog = function () {
				slideInModalService.closeModal();
			};
			$timeout(function () {
				var modelArgument = {
					scope: slideInScope,
					templateUrl: template,
					windowTemplateUrl: '/application/f/core/item-drilldown/item-drilldown-template.html',
					keyboard: false
				};
				if (args.type === 'Project') { 
					modelArgument['controller'] = 'editProject as editProjectController';
				}
				instance = slideInModalService.openModal(modelArgument);
				instance.result.then(function () {
					opened = false;
				});
				instance.result.catch(function () {
					jQuery('.inlineEditDiv').unbind();
					jQuery('.inlineEditDiv').remove();
					opened = false;
				});

				if (args.type === 'Issue' || args.type === 'Task') { 
					triggerProjectTaskIssueLoad(args.ndx, args.factoryNdx, args.projectNdx, args.type);
				}
			}, 0);
		}

		function triggerProjectTaskIssueLoad(ndx, factoryNdx, projectNdx, type) {
			var htmlElement = type === 'Task' ? 'projectTaskPanel' : 'projectIssuePanel';
			var element = angular.element(document.getElementById(htmlElement));
			if (!element || !element.scope()) {
				$timeout(function () {
					triggerProjectTaskIssueLoad(ndx, factoryNdx, projectNdx, type);
				}, 10);
				return;
			}
			var projectTaskIssueScope = element.scope();
			if (projectTaskIssueScope) {
				if (type === 'Task') { 
					projectTaskIssueScope.loadTask(ndx, factoryNdx, projectNdx);
				} else {
					projectTaskIssueScope.loadIssue(ndx, factoryNdx, projectNdx);
				}
			}
		}

		function viewA3Report(projNdx, factoryNdx) {
			if (!factoryNdx) {
				factoryNdx = globalConfig.factory.id;
			}
			var modalInstance = a3ModalService.openModal(projNdx, factoryNdx);

			modalInstance.result.finally(function () {
				a3ModalService.removeNoPrintClass();
			});
		}
	}
})();
